import { indexImagesByCode } from "@/helpers/mobImage/indexImagesByCode"

const CURRENCY_IMAGE_BY_CODE = indexImagesByCode(
  import.meta.glob("/src/assets/images/currencies/*.webp", {
    eager: true,
    import: "default"
  }) as Record<string, string>
)

export const resolveCurrencyImage = (code: string): string | undefined =>
  Object.hasOwn(CURRENCY_IMAGE_BY_CODE, code)
    ? CURRENCY_IMAGE_BY_CODE[code]
    : undefined
